import ModelElement from './v-element'
import { programElementTypes, libraryGroups } from '/@/shared/constants'
import { variableTypes, valueTypes } from '/@models/v-program/v-elements/v-element'

export default class ModelIf extends ModelElement {
  initVariables() {
    super.initVariables()

    this._type = programElementTypes.if
    this._title = 'if'
    this._icon = 'v-if'
    this._variable = ''
    this._operator = ''
    this._value = ''
    this._variableObjectID = null
    this._valueObjectID = null
    this._sortOrder = 0
    this._libraryGroup = libraryGroups.LOGIC
  }

  toJS(loadedProgramModels) {
    const variable = this.incorporateVariableGetCommand()
    const value = this.incorporateValueGetCommand()

    return `
      if(${variable} ${this.operator} ${value}){
        nop(new LineId("${this.id}"));
        ${this.children.map(c => c.toJS(loadedProgramModels)).join('\n')}
      }`
  }

  incorporateVariableGetCommand() {
    return this.variableType === variableTypes.PARAMETER //
      ? `get("${this.variable}")`
      : this.variable
  }

  incorporateValueGetCommand() {
    return this.valueType === valueTypes.PARAMETER //
      ? `get("${this.value}")`
      : this.value
  }
}
